module.exports = __webpack_public_path__ + "static/media/SOLID-SLATE-LOGO_Artboard 5.e9f42bb1.svg";